<template>
  <div class="flex flex-col space-y-4">
    <div class="flex flex-row flex-shrink-0">
      <span class="text-20px leading-23px">Шаг {{ index }}</span>
      <span class="ml-1 text-18px leading-21px transform -translate-y-1 text-muted-light">
        / {{ length }}
      </span>
    </div>
    <div class="flex flex-row space-x-4">
      <div
        :class="['max-w-40', 'h-1', 'flex-grow', {
          'bg-geyser': line !== parseInt(index, 10),
          'bg-primary': line === parseInt(index, 10)
        }]"
        v-for="(line, lineIndex) in lengthRange"
        :key="lineIndex"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    index: {
      type: [Number, String],
      required: true,
    },
    length: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    lengthRange() {
      return _.range(1, parseInt(this.length, 10) + 1);
    },
  },
};
</script>
